import { render, staticRenderFns } from "./ExpenseCreationSection.vue?vue&type=template&id=3b58c662&scoped=true"
import script from "./ExpenseCreationSection.vue?vue&type=script&lang=js"
export * from "./ExpenseCreationSection.vue?vue&type=script&lang=js"
import style0 from "./ExpenseCreationSection.vue?vue&type=style&index=0&id=3b58c662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b58c662",
  null
  
)

export default component.exports